export const PresentItem = [
  {
    img: 'https://p1.ssl.qhimg.com/t014376607fed92c96a.png',
    title: '专业的网站分析工具，网站概况一目了然',
    des: [
      {
        subtitle: '网站概况：',
        text: '网站基础流量、流量来源、访客信息、访客行为等基础数据，帮你解决宏观网站分析问题：有多少访客来到我们的网站？访客是从哪儿来？访客实际在我们网站上做了什么？与我们预期访客在网站上的行为是否相符？轻松掌握网站现状！'
      }, {
        subtitle: '实时数据：',
        text: '想第一时间掌握网站实时访客的信息吗？实时数据为您提供最新访客的来源、行为轨迹、访客地域以及搜索关键词等相关数据，助力实时进行网站推广优化、网站内容优化。'
      }
    ]
  }, {
    img: 'https://p4.ssl.qhimg.com/t01ab70ea64822c8c02.png',
    title: '掌握流量来源细分，洞察趋势，合理决策',
    des: [
      {
        subtitle: '流量来源：',
        text: '直接流量可衡量网站与用户互动、吸引用户回访的效果数据；搜索引擎流量对于网站十分重要，依托数据分析持续进行搜索引擎优化、搜索引擎推广；外部链接包括免费链接及付费广告。洞察网站流量组成趋势，持续优化决策。'
      }, {
        subtitle: '搜索词分析：',
        text: '想知道访客搜索哪些关键词进入你的网站？哪些关键词贡献流量较高？搜索词分析功能为你提供搜索词相关数据，可以通过跳出率指标区分高、低质量搜索词。'
      }
    ]
  }, {
    img: 'https://p2.ssl.qhimg.com/t0184a46495188a5d22.png',
    title: '打通点睛账户，转化与推广数据结合，智慧营销',
    des: [
      {
        subtitle: '搜索推广：',
        text: '想看到您在360搜索引擎上进行推广的真实转化效果吗？想在未来的搜索引擎推广上做出更加科学、准确的决策吗？搜索推广功能将搜索推广的转化与推广数据结合，依托数据分析，助您提升搜索推广效果！'
      }, {
        subtitle: '展示广告：',
        text: '展示广告功能将转化与推广数据结合，通过对推广账户内各层级数据深入分析，帮助您更及时精准地优化展示广告推广策略。通过持续的数据分析，提升展示广告的广告效果！'
      }
    ]
  }, {
    img: 'https://p0.ssl.qhimg.com/t012a66ad9d4e9aab5b.png',
    title: '深入了解网站访客，助力网站用户运营',
    des: [
      {
        subtitle: '访客地域：',
        text: '想要了解您网站真实的访客是来自哪些地域吗？访客地域数据为您展示您网站访客的地理分布，辅助您推广的地域决策。'
      }, {
        subtitle: '人群属性：',
        text: '你的网站访客有什么人群特征？与预期是否一致？人群属性数据展示网站访客的性别、年龄、学历、职业相关信息，帮您进一步了解网站访客。'
      }, {
        subtitle: '人群细分：',
        text: '想查看特定人群相关数据怎么办？人群细分功能帮助您实现自由划分人群，洞察目标人群，对不同人群进行差异化营销。'
      }
    ]
  }, {
    img: 'https://p2.ssl.qhimg.com/t018f16089a5c65748b.png',
    title: '站内行为分析，提升用户体验，持续优化网站',
    des: [
      {
        subtitle: '页面分析：',
        text: '网站哪些页面最受欢迎？哪些页面体验较差？页面分析数据为您展示不同场景下的页面表现，帮助您提升网站页面用户体验效果。'
      }, {
        subtitle: '热力图：',
        text: '页面的哪些内容被用户高度关注？通过热力图，直观了解用户页面的点击行为，帮助您优化页面设计，提升用户转化。'
      }, {
        subtitle: '转化效果：',
        text: '设置好您网站关注的转化目标后，转化分析报告为您展示各转化目标的转化数据，用来衡量网站推广的转化效果。'
      }
    ]
  }, {
    img: 'https://p1.ssl.qhimg.com/t0184e500b228f982ae.png',
    title: '移动应用推广数据，助力移动互联网时代营销',
    des: [
      {
        subtitle: '推广分析：',
        text: '推广分析数据为您展示应用推广的效果及推广数据，帮助您及时了解您的应用推广状态，依托数据分析，持续优化移动应用推广效果。'
      }, {
        subtitle: '渠道分析：',
        text: '了解移动应用推广各渠道的表现吗？渠道分析数据帮助您了解应用推广结果中各推广渠道的表现，洞察优质渠道，提升推广效果。'
      }, {
        subtitle: '地域分析：',
        text: '地域分析数据展示移动应用推广结果中各地域的表现情况，根据不同地域的表现结合自身应用推广战略目标，优化推广策略。'
      }
    ]
  }
]

export const AccountItem = [
  {
    title: '确立优化目标',
    img: 'https://p1.ssl.qhimg.com/t01bedcf2be37663ebe.png',
    notice: '近15天日均转化次数不低于20且有转化天数大于10天才会作为默认的优化目标，不满足此规则的账户只能优化展现点击。',
    context: '',
    des: [
      {
        'text': '优化展现点击：以展示、点击、CTR为优化目标进行账户优化；'
      }, {
        'text': '优化转化效果：以优化转化数量、转化成本为优化目标进行账户优化。'
      }
    ]
  }, {
    title: '选择优化思路',
    img: 'https://p1.ssl.qhimg.com/t0135d92944b108ca8b.png',
    notice: '小账户建议整体优化、大账户建议分计划优化',
    context: '',
    des: [
      {
        'text': '整体优化：对整个账户进行优化建议推荐；'
      }, {
        'text': '筛选出20个重点计划，进行优化建议推荐。'
      }
    ]
  }, {
    title: '账户问题诊断',
    img: 'https://p0.ssl.qhimg.com/t0148cd970076930005.png',
    notice: '',
    context: '',
    des: [
      {
        'text': '账户数据分析：结合行业数据，对账户展现、点击、消费、转化率进行数据分析；'
      }, {
        'text': '账户问题诊断：通过数据分析，诊断当前账户存在的问题并给出相应的优化建议，并给出预估效果。主要诊断问题包括：展现量问题、点击率问题、账户预算、投放时间问题、转化率问题。'
      }
    ]
  }, {
    title: '采纳优化建议',
    img: 'https://p1.ssl.qhimg.com/t01b1db9f613617a285.png',
    notice: '',
    context: '',
    des: [
      {
        'text': '采纳具体优化建议：优化建议主要包括关键词拓展、关键词优化、投放时间优化、整体预算优化、计划预算优化、暂停关键词；'
      }, {
        'text': '添加至操作列表：操作列表汇总想要采纳的所有优化建议，在操作列表中可对相关设置进行同步前的修改；'
      }, {
        'text': '进入操作列表同步点睛/下载模板：进入操作列表同步至点睛后，采纳的优化建议即可生效，或下载优化模板上传至点睛生效。'
      }
    ]
  }, {
    title: '查看优化效果',
    img: 'https://p1.ssl.qhimg.com/t01afbda00fd099907d.png',
    notice: '',
    context: '优化建议模板同步至点睛并生效，1天后可进入操作列表查看优化模板优化效果。',
    des: []
  }
]



// WEBPACK FOOTER //
// ./src/pageview/constants.js